import { type ErrorResult } from '@databases/types/confluence';
import { getJiraIssue } from '@databases/utils/confluence/jira';

import { DataLoaderService } from './base/data-loader-service';

export class JiraIssueDataLoader extends DataLoaderService<string, string> {
  private jiraBaseUrl?: URL;

  constructor(jiraBaseUrl?: URL, batchScheduleDelay?: number) {
    super(batchScheduleDelay);
    this.jiraBaseUrl = jiraBaseUrl;
  }

  setJiraBaseUrl(baseUrl: URL): void {
    this.jiraBaseUrl = baseUrl;
  }

  getJiraBaseUrl(): URL | undefined {
    return this.jiraBaseUrl;
  }

  protected batchLoad(issueKeys: readonly string[]): Promise<(string | ErrorResult)[]> {
    if (!this.jiraBaseUrl) {
      const error: ErrorResult = {
        message: 'Jira base URL is not configured',
        status: 500
      };
      return Promise.resolve(issueKeys.map(() => error));
    }

    return Promise.all(
      Array.from(issueKeys).map(async (issueKey) => {
        try {
          const jiraIssueResult =
            this.jiraBaseUrl && (await getJiraIssue(this.jiraBaseUrl, issueKey));
          if ('key' in jiraIssueResult) {
            return jiraIssueResult.key;
          }
          return {
            message: `Key not in response for ${issueKey}`,
            status: 500
          } as ErrorResult;
        } catch (error) {
          const errorResult = error as ErrorResult;
          return {
            message: `Search error for ${issueKey}: ${errorResult.message}`,
            status: errorResult.status
          };
        }
      })
    );
  }
}
